<template>
<!-- MODAL Link Device -->
  <div id="textAlertModal" class="col-12 justify-content-center" style="padding: 15vh 20%">
    <div class="col-12 m-0 p-0 section-container rounded-5 bg-caja sombra-modal">
      <div class="row overflow-hidden col-12 m-0 p-0 text-white rounded-top-5 pb-1 h-100 gradient-tablas">
        <div class="col-10">
          <h6 class="tx-left tx-white mb-2 ps-1 pt-2">
            <ion-icon name="hardware-chip" class="tx-18 me-2 align-bottom"></ion-icon>
              {{ (linkAction==='link') ?dictionary['Vincular'][session.user.language]:dictionary['Desvincular'][session.user.language] }}
          </h6>
        </div>
        <div class="col-2 m-0 p-0 d-flex justify-content-end btn" @click="this.$emit('dismissAlert')">	
          <ion-icon name="close" class="ms-auto tx-30 pt-1 pe-1 tx-white align-bottom"></ion-icon>
        </div>
      </div>

      <div class="form-group col-12 p-0 pe-3">
        <div id="linkDeviceScroll" class="col-12 p-3" style="overflow: scroll; overflow-x: hidden; max-height: 60vh;">
          <div class="row col-12 border border rounded m-0 p-1 pb-0">
            <div class="col-lg-4 col-12">
              <div class="col-12 m-0 p-2 d-flex flex-column tx-left">
                <span class="col-12 m-0 p-0 tx-bold tx-14">
                  {{ dictionary['Dispositivo'][session.user.language]+": " }}
                </span>
                <span class="col-12 m-0 p-0 tx-12">
                  {{ targetDeviceId }}
                </span>
              </div>
            
              <div v-if="linkAction === 'link'" 
              class="col-12 m-0 p-2 d-flex flex-column tx-left">
                <span class="col-12 m-0 p-0 pb-2 tx-bold tx-14">
                  {{dictionary['Emplazamiento'][session.user.language]+": " }}
                </span>
                <select class="col-12 m-0 p-0 form-control p-2 h-100 bg-white d-flex" style="color:black; line-height:"
                :value="targetEmplacementId"
                @change="onTargetEmplacement">
                  <option v-for="emplacement in availableEmplacements" :key="emplacement"
                  :value="emplacement.id">
                    {{ emplacement.label }}
                  </option>
                </select>
              </div>
              <div class="col-lg-12 col-md-12 col-12 p-2 ps-1 pe-1">
<!-- SUBMIT -->
                <button type="button" id="btnSubmitTargetDevice" class="button-ok gradient-tablas w-100"
                @click="linkDeviceToEmplacement">
                  {{dictionary['Aceptar'][session.user.language]}}
                </button>
              </div>

              <div class="col-lg-12 col-md-12 col-12 p-2 ps-1 pe-1">
<!-- DISMISS -->
                <button type="button" id="btnCancelTargetDevice" class="button-ok gradient-tablas w-100"
                @click="this.$emit('dismissAlert')">
                  {{dictionary['Cancelar'][session.user.language]}}
                </button>
              </div>
          </div>

            <div v-if="linkAction === 'link'" 
            class="col-lg-8 col-md-8 col-12 m-0 p-2 d-flex flex-column tx-left">
             <!-- <span class="col-12 m-0 p-0 tx-bold tx-14 ms-4">
                {{dictionary['Posición'][session.user.language]+": " }}
              </span>-->

              <div class="col-12 d-flex flex-wrap justify-content-center bg-menu rounded-5 text-center m-0 p-3">
                <div class="blueprintCanvas w-100 m-0 p-0">
                  <img id="emplacementBlueprintForDevice" class="w-100 m-0 p-0"
                  @click="onSetNewCoordinates"
                  :src="displayBlueprint()">
                  <div id="linkDeviceBlueprintMarker" style="color: red;">
                    <ion-icon name="locate-outline" class="tx-20"></ion-icon>
                  </div>
                </div>
<!-- LATITUD -->
                <div class="col-lg-6 col-12 m-0 p-2" style="text-align: left;">
                  <label class="m-0 p-0 tx-13 tx-clomos-white">
                    {{dictionary['Latitud'][session.user.language]}} *
                  </label><br>
                  <input v-model="newGeoJSON.geometry.coordinates[0]" 
                  id="inputLinkDevciceLat" type="number" step=0.00001
                  class="form-control form-control-line bg-white" style="color:black;" 
                  @change="onPositionChanged">
                </div>

<!-- LONGITUD -->
                <div class="col-lg-6 col-12 m-0 p-2" style="text-align: left;">
                  <label class="m-0 p-0 tx-13 tx-clomos-white">
                    {{dictionary['Longitud'][session.user.language]}} *
                  </label><br>
                  <input v-model="newGeoJSON.geometry.coordinates[1]" 
                  id="inputLinkDevciceLng" type="number" step=0.00001
                  class="form-control form-control-line bg-white" style="color:black;" 
                  @change="onPositionChanged">
                </div>
              </div>
            </div>
            
            <div v-else
            class="col-lg-8 col-md-8 col-12 m-0 p-2 d-flex flex-column tx-left">
              <!--<span class="col-12 m-0 p-0 tx-bold tx-clomos-midtone">
                {{dictionary['Posición'][session.user.language]+": " }}
              </span>-->

              <div class="col-12 d-flex flex-wrap justify-content-center bg-menu rounded-5 text-center m-0 p-3">
                <div id="deviceMapContent" class="m-0 p-3" style="width: 100%; height: 275px; index: 0; border-radius: 0.5rem;">
                </div>
<!-- LATITUD -->
                <div class="col-lg-6 col-12 m-0 p-2" style="text-align: left;">
                  <label class="m-0 p-0 tx-13 tx-clomos-white">
                    {{dictionary['Latitud'][session.user.language]}} *
                  </label><br>
                  <input v-model="newGeoJSON.geometry.coordinates[0]" 
                  id="inputLinkDeviceLat" type="number" step=0.00001 
                  class="form-control form-control-line bg-white" style="color:black;" 
                  @change="onPositionChanged">
                </div>

<!-- LONGITUD -->
                <div class="col-lg-6 col-12 m-0 p-2" style="text-align: left;">
                  <label class="m-0 p-0 tx-13 tx-clomos-white">
                    {{dictionary['Longitud'][session.user.language]}} *
                  </label><br>
                  <input v-model="newGeoJSON.geometry.coordinates[1]" 
                  id="inputLinkDeviceLng" type="number" step=0.00001 
                  class="form-control form-control-line bg-white" style="color:black;" 
                  @change="onPositionChanged">
                </div>
              </div>
            </div>

            <div class="row m-0 p-2">

              

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import $ from 'jquery';
import Leaflet from 'leaflet';
// Clomos
import api from '@/services/api';

export default {
  name: "TargetDeviceModal",
  props: {
    session: {
      type: Object,
      requiered: true,
    },
    dictionary: {
      type: Object,
      requiered: true,
    },
    targetDeviceId: {
      type: String,
      requiered: true,
    },
    linkAction: {
      type: String,
      requiered: true,
    },
    currentCompany: {
      type: Object,
      requiered: true,
    },
  },
  data() {
    return {
      targetDeviceData: {},
      targetEmplacementId: "",
      targetEmplacement: {},
      availableEmplacements: [],
      newGeoJSON: { 
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [0,0]
        }
      },
      deviceMap: undefined,
      deviceMarker: undefined
    }
  },
  computed: {
    bluePrintMarkerPosition() {
      let markerX = 0;
      let markerY = 0;
      let blueprintCanvas = document.getElementById('emplacementBlueprintForDevice');
      if (blueprintCanvas != null) {
        let ratioX = blueprintCanvas.naturalWidth / blueprintCanvas.offsetWidth;
        let ratioY = blueprintCanvas.naturalHeight / blueprintCanvas.offsetHeight;
        
        let domX = this.newGeoJSON.geometry.coordinates[0] - blueprintCanvas.offsetLeft + 25 ;
        let domY = this.newGeoJSON.geometry.coordinates[1] - blueprintCanvas.offsetTop + 25;
  
        markerX = Math.floor(domX / ratioX);
        markerY = Math.floor(domY / ratioY);
      }
      return "color: red; position: absolute; top: " + markerY +"px; left: " + markerX + "px;"
    }
  },
  emits: ["dismissAlert"],
  methods: {
    // DISPLAY
    displayMap() {
      if (this.deviceMap != undefined) {
        this.deviceMap.invalidateSize();
        this.deviceMap.remove();
      }
      var deviceMap = Leaflet.map("deviceMapContent");
      Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?lang='+this.session.user.language,{maxZoom: 19}).addTo(deviceMap);
      deviceMap.on('click', this.onSetNewCoordinates)
      
      this.deviceMap = deviceMap;
      
      let deviceMapListForGroup = []; 
      if ($(".leaflet-control-attribution").get()[0] != undefined) $(".leaflet-control-attribution").get()[0].remove();
      var deviceMarker = Leaflet.marker([this.newGeoJSON.geometry.coordinates[0],this.newGeoJSON.geometry.coordinates[1]]);
      deviceMarker.addTo(deviceMap);
      deviceMapListForGroup.push(deviceMarker);
      var deviceMapGroup = Leaflet.featureGroup(deviceMapListForGroup);
      this.deviceMap.fitBounds(deviceMapGroup.getBounds());

      this.deviceMarker = deviceMarker;
    },
    displayBlueprint() {
      let src = "";
      if (this.targetEmplacement != undefined
      && this.targetEmplacement.variables != undefined
      && this.targetEmplacement.variables.dynamic != undefined
      && this.targetEmplacement.variables.dynamic.urlPlano != undefined)
        src = this.targetEmplacement.variables.dynamic.urlPlano.value;
      if (src!=undefined && src!='') {
        try {
          return this.$clientConfig.api + '/ficheros/ficheros.php?fichero='+src+'&identificadorusuario='+this.session.user.id+'&Token='+localStorage.getItem("ClomosAuthToken");
        }
        catch(e) { 
          console.warn(e);
        }
      }
      return require('/src/assets/img/placeholder_image.jpg');
    },
    onPositionChanged() {
      if (this.linkAction==="link")
        document.getElementById('linkDeviceBlueprintMarker').style = this.bluePrintMarkerPosition;
      else {
        this.deviceMap.removeLayer(this.deviceMarker);
        this.deviceMarker = Leaflet.marker([this.newGeoJSON.geometry.coordinates[0],this.newGeoJSON.geometry.coordinates[1]]).addTo(this.deviceMap);
      }
    },
    // GET
    async getTargetDeviceData(callback) {
      let response = await api.getDeviceData(this.targetDeviceId);
      this.targetDeviceData = api.parseDeviceFromResponse(response);
      if (callback && typeof callback === "function") callback(this.targetDeviceData);
    },
    async getEmplacementList(callback) {
      let request = {
        nifCif: this.currentCompany.nifCif,
        limit: 0,
        offset: 0,  
        where: "",
      };
      let response = await api.getEmplacementList(request);
      this.availableEmplacements = api.parseEmplacementsFromResponse(response);
      if (callback && typeof callback === "function") callback(this.availableEmplacements);
    },
    // TARGET
    onTargetEmplacement(event) {
      this.targetEmplacementId = event.target.value;
      for (let i in this.availableEmplacements) {
        if (this.availableEmplacements[i].id === this.targetEmplacementId) 
        this.targetEmplacement = this.availableEmplacements[i];
        if (this.targetEmplacement != undefined
        && this.targetEmplacement.variables != undefined
        && this.targetEmplacement.variables.dynamic != undefined
        && this.targetEmplacement.variables.dynamic.urlPlano != undefined) {  
          this.displayBlueprint();
          this.newGeoJSON.properties = {srcId: this.targetEmplacement.variables.dynamic.urlPlano}
        }
      }
    },
    // SET 
    onSetNewCoordinates(event) {
      if (this.linkAction==="link") {
        let target = event.target;
        let totalOffsetLeft = target.offsetLeft;
        let totalOffsetTop = target.offsetTop;
        let totalScrollLeft = target.scrollLeft;
        let totalScrollTop = target.scrollTop;
        while (target.offsetParent != undefined) {
          target = target.offsetParent;
          totalOffsetLeft += target.offsetLeft;
          totalOffsetTop += target.offsetTop;
          totalScrollLeft += target.scrollLeft;
          totalScrollTop += target.scrollTop;
        }
        let ratioX = event.target.naturalWidth / event.target.offsetWidth;
        let ratioY = event.target.naturalHeight / event.target.offsetHeight;

        let domX = event.x + totalScrollLeft - totalOffsetLeft;
        let domY = event.y + totalScrollTop - totalOffsetTop;

        this.newGeoJSON.geometry.coordinates[0] = Math.floor(domX * ratioX);
        this.newGeoJSON.geometry.coordinates[1] = Math.floor(domY * ratioY);

        this.onPositionChanged();
      }
      else {
        this.newGeoJSON.geometry.coordinates = [ 
          Number(event.latlng.lat),
          Number(event.latlng.lng)
        ]
        this.deviceMap.removeLayer(this.deviceMarker);
        this.deviceMarker = Leaflet.marker([this.newGeoJSON.geometry.coordinates[0],this.newGeoJSON.geometry.coordinates[1]]).addTo(this.deviceMap);
      }
    },
    async linkDeviceToEmplacement(callback) {
      let request = {
        deviceId : this.targetDeviceId,
        emplacementId : this.targetEmplacementId,
        geoJSON : this.newGeoJSON
      }
      let response = await api.setDeviceParent(request);
      if (response["status-code"]==="200") this.$emit('dismissAlert');
      if (callback && typeof callback === "function") callback(this.availableEmplacements);
    }
  },
  async created() {
    await this.getTargetDeviceData();
    if (this.linkAction === "link") {
      await this.getEmplacementList();
      if (this.availableEmplacements[0]!=undefined)
        this.targetEmplacementId = this.availableEmplacements[0].id;
    }
    else 
      this.targetEmplacementId = "";
      if (this.linkAction === "link") setTimeout(()=>{this.onPositionChanged()}, 300);
      else setTimeout(()=>{this.displayMap()}, 300);
  }
}
</script>

<style>
#textAlertModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}
</style>